import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import Animated from 'react-native-reanimated';
import { useAppSelector, useAppStore } from 'store/hooks';
import { AppView, HelpCallToAction, Spacer } from 'design-system';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import { SCROLL_INDICATOR_INSETS } from 'design-system/values';
import { muteAll, useFetchOld } from 'hooks';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import { useMarginBottom } from 'hooks/useMarginBottom';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { HELP_ARTICLES_KEY } from 'features/help/constants';
import { getAutosaveActivities } from 'features/pots/actions';
import AutosaveActivitySection from 'features/pots/components/AutosaveActivitySection';
import AutosaveSettingsSection from 'features/pots/components/AutosaveSettingsSection';
import DirectDebitSection from 'features/pots/components/DirectDebitSection';
import Links from 'utils/links';
import { isWeb } from '../../../../constants';
const AutoSave = withAnimatedNavigationHeader(({ navigation, scrollHandler }) => {
    const autoSaveId = useAppSelector((state) => state.pots.savingsPlan?.id);
    const store = useAppStore();
    const [, , , fetch] = useFetchOld(muteAll);
    useLayoutEffect(() => {
        navigation.setOptions({
            headerRight: () => <HelpScreenButton articlesKey={HELP_ARTICLES_KEY.AUTOSAVE}/>,
        });
    }, []);
    useEffect(() => {
        const getAutosaveActivitiesFn = async () => {
            fetch(getAutosaveActivities({
                page: 1,
                perPage: 30,
            }));
        };
        if (!store.getState().unpersistedPotsReducer.fetchingAutosaveActivities) {
            getAutosaveActivitiesFn();
        }
    }, []);
    useEffect(() => {
        if (!autoSaveId) {
            navigation.pop();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const onHelpPress = useCallback(() => {
        Links.openKnownLink('autosaveInfo');
    }, []);
    const { paddingHorizontalStyle } = useAppFrameDimensions(isWeb);
    const contentContainerStyle = useMarginBottom('paddingBottom', undefined, paddingHorizontalStyle);
    return (<AppView type="secondary" withFrame={false}>
        <Animated.ScrollView scrollEventThrottle={16} onScroll={scrollHandler} contentContainerStyle={contentContainerStyle} scrollIndicatorInsets={SCROLL_INDICATOR_INSETS}>
          {autoSaveId ? (<>
              <Spacer h={16}/>
              <DirectDebitSection autoSaveId={autoSaveId}/>
              <AutosaveActivitySection />
              <AutosaveSettingsSection />
              <Spacer.H16 />
              <HelpCallToAction onDark onPress={onHelpPress} title="Want to have more details?" subTitle="Learn more about Autosave"/>
            </>) : null}
        </Animated.ScrollView>
      </AppView>);
}, ({ colors }) => ({
    title: 'Autosave',
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
export default AutoSave;
